/** Specifies the project skin types */
export enum ProjectSkinType {
  Unknown = "Unknown",
  WebHelp2 = "WebHelp2",
}
